import React, { useMemo } from 'react';
import FilterDropdown from './Filter/components/FilterDropdown';
import { translate } from '../services/translate';
import { StyleProp, TextStyle } from 'react-native';
import { UseFormReturn } from 'react-hook-form';
import FormDropDownPicker from './FormDropDownPicker';

type Props = {
    zIndex: number;
    labelStyle?: StyleProp<TextStyle>;
    viewStyle?: StyleProp<TextStyle>;
    required?: boolean;
    includesXlsx: boolean;
    onOpen?: () => void;
    onClose?: () => void;
    disabled?: boolean;
} & ({
    form?: undefined;
    fieldName?: undefined;
    customValidations?: undefined;
    pattern?: undefined;
    value: 'pdf' | 'csv' | 'xlsx' | '';
    setValue: React.Dispatch<React.SetStateAction<'pdf' | 'csv' | 'xlsx' | ''>>;
} | {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    form: UseFormReturn<any, any, any>;
    fieldName: string;
    value?: undefined;
    setValue?: undefined;
});

export default function FileFormatDropdown({ setValue, value, zIndex, labelStyle, viewStyle, form, fieldName, required, includesXlsx, onOpen, onClose, disabled }: Props) {
    const items = useMemo(() => [
        { label: 'pdf', value: 'pdf' },
        { label: 'csv', value: 'csv' },
        { label: 'xlsx', value: 'xlsx' },
    ].filter(item => includesXlsx || item.value !== 'xlsx').map(item => ({
        label: item.label.toUpperCase(),
        value: item.value,
    })), [includesXlsx]
    );

    if (form && fieldName) {
        return <FormDropDownPicker
            label={translate('fileExtension')}
            items={items}
            multiple={false}
            fieldName={fieldName}
            form={form}
            zIndex={zIndex}
            required={required}
            onOpen={onOpen}
            onClose={onClose}
            disabled={disabled}
        />;
    } else if (value !== undefined && setValue !== undefined) {
        return (
            <FilterDropdown
                label={translate('fileExtension')}
                items={items}
                multiple={false}
                setValue={setValue}
                value={value}
                zIndex={zIndex}
                labelStyle={labelStyle}
                viewStyle={viewStyle}
                required={required}
                onOpen={onOpen}
                onClose={onClose}
                disabled={disabled}
            />
        );
    }
}
